import '@/instrument'

import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { createRoutesFromElements, createBrowserRouter, Route } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import { Theme } from '@radix-ui/themes'
import { Subscription, loader as subscriptionLoader } from '@/pages/subscription/index'
import { SubscriptionNew, loader as subscriptionNewLoader } from '@/pages/subscription/new/index'
import { SubscriptionSubscribed, loader as subscriptionSubscribedLoader } from '@/pages/subscription/subscribed/index'
import { SubscriptionLogin, loader as subscriptionLoginLoader } from '@/pages/subscription/login/index'
import { SubscriptionMypageLayout, loader as mypageLayoutLoader } from '~/pages/subscription/mypage/index'
import { SubscriptionMypageTop, loader as subscriptionTopLoader } from '~/pages/subscription/mypage/top/index'
import { SubscriptionMypageSkip, loader as subscriptionSkipLoader } from '~/pages/subscription/mypage/skip/index'
import { SubscriptionMypageAddress, loader as subscriptionAddressLoader } from '~/pages/subscription/mypage/address/index'
import { SubscriptionMypageCancel, loader as subscriptionCancelLoader } from '~/pages/subscription/mypage/cancel/index'
import { SubscriptionMypageCard, loader as subscriptionCardLoader } from '~/pages/subscription/mypage/card/index'
import { SubscriptionMypageEmail } from '~/pages/subscription/mypage/email/index'
import { SubscriptionMypagePassword  } from '~/pages/subscription/mypage/password/index'
import { SubscriptionMypageDelete, loader as subscriptionDeleteLoader } from '~/pages/subscription/mypage/delete/index'

import '@acab/reset.css'
import '@radix-ui/themes/styles.css'
import '@/styles/themes.css'

import '@fontsource-variable/noto-sans-jp'
import '@fontsource-variable/noto-sans'
import '@fontsource-variable/inter'

const ErrorPage = () => <></> // TODO

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" errorElement={<ErrorPage />}>
      <Route path="subscription" element={<Subscription />} loader={subscriptionLoader} />
      <Route path="subscription/new" element={<SubscriptionNew />} loader={subscriptionNewLoader} />
      <Route path="subscription/subscribed" element={<SubscriptionSubscribed />} loader={subscriptionSubscribedLoader} />
      <Route path="subscription/login" element={<SubscriptionLogin />} loader={subscriptionLoginLoader} />
      <Route element={<SubscriptionMypageLayout />} loader={mypageLayoutLoader} id={'mypageLayout'}>
        <Route path="subscription/mypage" element={<SubscriptionMypageTop />} loader={subscriptionTopLoader} />
        <Route path="subscription/mypage/skip" element={<SubscriptionMypageSkip />} loader={subscriptionSkipLoader} />
        <Route path="subscription/mypage/address" element={<SubscriptionMypageAddress />} loader={subscriptionAddressLoader} />
        <Route path="subscription/mypage/cancel" element={<SubscriptionMypageCancel />} loader={subscriptionCancelLoader} />
        <Route path="subscription/mypage/card" element={<SubscriptionMypageCard />} loader={subscriptionCardLoader} />
        <Route path="subscription/mypage/email" element={<SubscriptionMypageEmail />} />
        <Route path="subscription/mypage/password" element={<SubscriptionMypagePassword />} />
        <Route path="subscription/mypage/delete" element={<SubscriptionMypageDelete />} loader={subscriptionDeleteLoader} />
      </Route>
    </Route>
  )
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorPage />}>
      <Theme accentColor="orange" grayColor="sand" appearance="light">
        <RouterProvider router={router} />
      </Theme>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
